export default "__VITE_ASSET__91Y4eIwA__"